module.exports = __webpack_public_path__ + "img/info_error_24dp.c122b211.svg";